import { isMobileDevice } from '../utils/device.js';

export class MobileStatsOverlay {
    constructor(game) {
        this.game = game;
        this.enabled = false;
        this.isMobile = isMobileDevice();
        this.container = null;
        this.coinValueEl = null;
        this.killValueEl = null;

        this.createOverlay();
    }

    createOverlay() {
        // MobileStatsOverlay is now replaced by the unified game status bar
        // This component is deprecated and no longer creates UI elements
        return;

    }

    show() {
        // Deprecated - now using unified game status bar
        this.enabled = false;
    }

    hide() {
        // Deprecated - now using unified game status bar
        this.enabled = false;
    }

    update() {
        // Deprecated - now using unified game status bar
        return;
    }

    destroy() {
        if (this.container && this.container.parentNode) {
            this.container.parentNode.removeChild(this.container);
        }
        this.container = null;
        this.coinValueEl = null;
        this.killValueEl = null;
    }
}
